module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "goodsBigScreen",
    style: ({
      backgroundImage: ("url(" + _vm.backgroundImage + ")"),
      color: _vm.textColor
    }),
    attrs: {
      "id": "goodsBigScreen"
    }
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "tit"
  }, [_vm._v("制作中")]), _vm._v(" "), _c('div', {
    staticClass: "sub-tit"
  }, [_vm._v("PREPARING")]), _vm._v(" "), (_vm.ingOrder.length) ? _c('div', {
    staticClass: "list"
  }, _vm._l((_vm.ingOrder), function(it, ind) {
    return _c('span', {
      key: ind,
      staticClass: "item",
      class: {
        bold: _vm.isBold == 1
      }
    }, [_vm._v("\n        " + _vm._s(it.code) + "\n      ")])
  }), 0) : _c('div', {
    staticClass: "list no-data"
  }, [_vm._v("暂无数据...")])]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('div', {
    staticClass: "tit"
  }, [_vm._v("请取餐")]), _vm._v(" "), _c('div', {
    staticClass: "sub-tit"
  }, [_vm._v("READY")]), _vm._v(" "), (_vm.deliveryOrder.length) ? _c('div', {
    staticClass: "list"
  }, _vm._l((_vm.deliveryOrder), function(it, ind) {
    return _c('span', {
      key: ind,
      staticClass: "item"
    }, [_c('div', {
      staticClass: "cont",
      class: {
        bold: _vm.isBold == 1
      }
    }, [_vm._v("\n          " + _vm._s(it.code) + "\n          "), _c('div', {
      staticClass: "emp-name"
    }, [_vm._v("\n            (" + _vm._s(it.deliveryName ? ((it.deliveryName) + "~") : "") + _vm._s(it.tableNo ? ((it.tableNo) + "号机~") : "") + _vm._s(_vm.formatTime(it.makeTime)) + ")\n          ")])])])
  }), 0) : _c('div', {
    staticClass: "list no-data"
  }, [_vm._v("暂无数据...")]), _vm._v(" "), (_vm.showGetOrder) ? _c('div', {
    staticClass: "pls-get"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "inner-wrap"
  }, [_c('div', {
    staticClass: "num"
  }, [_vm._v("\n          " + _vm._s(_vm.nowGetItem.code) + "\n          "), _c('div', {
    staticClass: "emp-name"
  }, [_vm._v(_vm._s(_vm.nowGetItem.deliveryName))])])])]) : _vm._e()]), _vm._v(" "), _c('form', {
    staticClass: "submit-code",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.checkOrder.apply(null, arguments)
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.code),
      expression: "code"
    }],
    staticClass: "inp",
    attrs: {
      "id": "inp",
      "autofocus": "",
      "type": "password"
    },
    domProps: {
      "value": (_vm.code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.code = $event.target.value
      }
    }
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tit-wrap"
  }, [_c('div', {
    staticClass: "pls-tit"
  }, [_vm._v("请取餐")]), _vm._v(" "), _c('div', {
    staticClass: "pls-sub-tit"
  }, [_vm._v("READY")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-649f099a","hasScoped":true}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/goodsBigScreen/index.vue
// module id = 953
// module chunks = 1